module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/point02-33363717244f68ddf80f2702768fd223.png";